import "bootstrap-icons/font/bootstrap-icons.css";

import React from "react";
import { Col, Container } from "react-bootstrap";
import parse from "html-react-parser";

import EnquiryForm from "components/forms/EnquiryForm";

import ContactUs from "assets/images/coming-soon/contact-us.png";
import EmailUs from "assets/images/coming-soon/email-us.png";
import LocateUs from "assets/images/coming-soon/locate-us.png";
import { formatTitleWithItalic } from "utils";

function LetsConnect({ data }) {
  const icons = [ContactUs, EmailUs, LocateUs];
  return (
    <Container className="container lets-connect">
      <div className="inward-container">
        <div data-aos="fade-up" data-aos-delay="150" className="mb-5">
          <h1 className="heading mb-4 text-center">Let's connect!</h1>
          <p style={{ color: "var(--alrajhi-black)", textAlign: "center" }}>
            Share your information, and we'll get back to you with the answers
            you need.
          </p>
        </div>
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-8 mb-4">
            <EnquiryForm />
          </div>
          <div className="col-xl-4 text-center">
            {data?.contactData?.map((item, index) => (
              <Col
                className="contact-box"
                data-aos="fade-up"
                data-aos-delay="150"
                key={index}
              >
                <div className="coming-soon-image-container">
                  <img
                    src={item?.image || item?.image_link}
                    alt={`ICON ${index}`}
                    className="d-block"
                    width="100%"
                  />
                </div>
                <div>
                  <h6>{formatTitleWithItalic(item.name)}</h6>
                  {item.description && <p>{parse(item.description)}</p>}
                </div>
              </Col>
            ))}
          </div>
        </div>
      </div>
    </Container>
  );
}

export default LetsConnect;
